import { type FC } from "react";
import { Card, CardRowSimple, formatDateTimeFromISO, type GridCard, TimeAgo } from "widgets";

import { RelativeUserLabel } from "@/modules/users/components/RelativeUserLabel.js";

import { type Project, type User } from "../../../graphql.js";
import { getProjectLabel } from "../../../redux/modules/config.js";

export interface IMetadataCardProps extends GridCard {
  project: Project;
  user: User;
}

const MetadataCard: FC<IMetadataCardProps> = ({ project }) => {
  if (!project) {
    return null;
  }

  return (
    <Card key="project-metadata-info-card" title={`${getProjectLabel(true, false)} Information`} shrinkable={true}>
      <CardRowSimple label="Description" value={project.description} />
      {project.creator && (
        <CardRowSimple label="Created by">
          <RelativeUserLabel user={project.creator} />
        </CardRowSimple>
      )}
      <CardRowSimple label="Created">
        <TimeAgo dateTimeISO={project.created} />
      </CardRowSimple>
      <CardRowSimple label="Last use">
        {project.lastModified ? <TimeAgo dateTimeISO={project.lastModified} /> : <>&ndash;</>}
      </CardRowSimple>
      <CardRowSimple label="Last update">
        {project.lastUpdate ? <TimeAgo dateTimeISO={project.lastUpdate} /> : <>&ndash;</>}
      </CardRowSimple>
      <CardRowSimple label="Start date" value={formatDateTimeFromISO(project.startDate, { hideTime: true })} />
      <CardRowSimple
        label="Projected end date"
        value={formatDateTimeFromISO(project.projectedEndDate, { hideTime: true })}
      />
      <CardRowSimple
        label="Initial end date"
        value={formatDateTimeFromISO(project.initialEndDate, { hideTime: true })}
      />
      <CardRowSimple label="Actual end date" value={formatDateTimeFromISO(project.actualEndDate, { hideTime: true })} />
      <CardRowSimple label="Status" value={project.status} />
      <CardRowSimple label="Status notes" value={project.statusNotes} />
      <CardRowSimple label="End notes" value={project.endNotes} />
    </Card>
  );
};

export { MetadataCard };
